import type { HTMLAttributes } from "react";
import arrowIn from "./assets/arrow-in.svg";
import arrowOut from "./assets/arrow-out.svg";
import dot from "./assets/dot.svg";

export type ListDropIndicatorDirection = "in" | "out" | "up" | "down";

export type ListDropIndicatorProps = Omit<
  HTMLAttributes<HTMLDivElement>,
  "children"
> & {
  direction: ListDropIndicatorDirection;
};

const indicatorAsset: Record<ListDropIndicatorDirection, string> = {
  in: arrowIn,
  out: arrowOut,
  up: dot,
  down: dot,
};

export default function ListDropIndicator({
  direction,
  className = "",
  ...props
}: ListDropIndicatorProps) {
  return (
    <div
      className={`flex w-full items-center justify-end gap-0.5 rounded-[17px] ${className}`}
      data-direction={direction}
      {...props}
    >
      <img
        src={indicatorAsset[direction]}
        alt=""
        className="block max-w-none shrink-0"
        aria-hidden="true"
      />
      <div className="h-[3px] min-w-0 flex-1 rounded-[17px] bg-[#31bbb3]" />
    </div>
  );
}
